export type BreakpointName = '_' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl';
export type Breakpoint = { name: BreakpointName; min: number | null };
export type Responsive<T> = Partial<Record<BreakpointName, T>>;

export const BREAKPOINTS: Array<Breakpoint> = [
  { name: 'xxl', min: 1280 },
  // we doesn't change xl for Backward Compatibility
  { name: 'xl', min: 1120 },
  { name: 'lg', min: 960 },
  { name: 'md', min: 768 },
  { name: 'sm', min: 480 },
  { name: '_', min: null },
];

export function createMediaQuery(
  min: number | null | undefined,
  max: number | null | undefined,
): string {
  const parts = [
    min != null && `(min-width: ${min}px)`,
    max != null && `(max-width: ${max - 1}px)`,
  ].filter((x) => x);
  if (parts.length === 0) return '';
  return `${parts.join(' and ')}`;
}
